module.exports = __webpack_public_path__ + "static/media/fan3_lamp0.940b32f6.gif";